module.exports = __webpack_public_path__ + "img/consultation-fee-mobile-fr.85eadc2f.jpg";